import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { mapCurrencyToLocale } from './localisation'

dayjs.extend(utc)

export const base64Encode = (value: string): string => window.btoa(encodeURIComponent(value))

export const base64Decode = (value: string): string => decodeURIComponent(window.atob(value))

export const formatDateAndTime = (value: string | Date): string =>
    dayjs.utc(value).local().format('DD/MM/YYYY HH:mm:ss.SSS')

export const formatCurrencyAndAmount = (currency: string, amount: string | number): string =>
    Intl.NumberFormat(mapCurrencyToLocale(currency), { style: 'currency', currency }).format(Number(amount))

const upperCaseFirstLetter = (word: string) => {
    const firstLetter = word.charAt(0)

    const firstLetterCap = firstLetter.toUpperCase()

    const remainingLetters = word.slice(1)

    return firstLetterCap + remainingLetters
}
const splitCompactStrings = (str: string) => {
    return str.split(/(?=[A-Z])/).join(' ')
}

export const formatJSONKeys = (val: string) => {
    return upperCaseFirstLetter(splitCompactStrings(val).toLowerCase())
}

export const formatEnums = (val: string) => {
    return upperCaseFirstLetter(val.toLowerCase().split('_').join(' '))
}
